import type { SxProps } from '@mui/material';
import type { MobileOrDesktop } from '@repo/utils/deviceType/types';
import { CalculatorSectionLayout } from './index';
import { CompoundCalculator } from './CompoundCalculator';
import { CALCULATOR_SECTION_COPY } from './constants';

export type CompoundCalculatorSectionProps = {
  containerSX?: SxProps;
  defaultApy?: number;
  deviceType?: MobileOrDesktop;
};

export function CompoundCalculatorSection({
  containerSX,
  defaultApy = 4.35,
  deviceType,
}: CompoundCalculatorSectionProps) {
  const copy = CALCULATOR_SECTION_COPY.compound;

  return (
    <CalculatorSectionLayout
      containerSX={containerSX}
      deviceType={deviceType}
      variant="compound"
      title={copy.title}
    >
      <CompoundCalculator defaultApy={defaultApy} />
    </CalculatorSectionLayout>
  );
}
